import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../index';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    // Prevent caching - use standard no-cache headers
    headers.set('Cache-Control', 'no-cache');
    headers.set('Pragma', 'no-cache');
    return headers;
  },
});

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'Auth',
    'Content',
    'Folders',
    'Playlists',
    'Layouts',
    'Displays',
    'DisplayGroups',
    'Schedules',
    'Analytics',
    'Users',
    'Workspaces',
  ],
  endpoints: () => ({}),
});
